/* CN Article Body — Table of Contents */
(function () {
  function init() {
    var content = document.getElementById('cn-article-content');
    var tocNav = document.getElementById('cn-toc-nav');
    var tocWrapper = document.getElementById('cn-toc-wrapper');

    if (!content || !tocNav) return;

    var allHeadings = content.querySelectorAll('h2');
    var headings = [];
    for (var i = 0; i < allHeadings.length; i++) {
      if (!allHeadings[i].closest('.cn-generic-subscribe')) {
        headings.push(allHeadings[i]);
      }
    }

    if (headings.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'cn-toc__empty body-small';
      empty.textContent = 'No sections in this article.';
      tocNav.appendChild(empty);
      return;
    }

    var list = document.createElement('ul');
    list.className = 'cn-toc__list';

    for (var hi = 0; hi < headings.length; hi++) {
      var h = headings[hi];
      var slug = h.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

      // Ensure unique IDs
      var id = slug;
      var count = 1;
      while (document.getElementById(id)) {
        id = slug + '-' + count;
        count++;
      }
      h.id = id;

      var li = document.createElement('li');
      li.className = 'cn-toc__item cn-toc__item--' + h.tagName.toLowerCase();

      var a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'cn-toc__link';
      a.textContent = h.textContent.trim();

      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(this.getAttribute('href').slice(1));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });

      li.appendChild(a);
      list.appendChild(li);
    }

    tocNav.appendChild(list);

    // Scroll spy
    var links = tocNav.querySelectorAll('.cn-toc__link');

    function onScroll() {
      var scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      var active = -1;

      for (var j = 0; j < headings.length; j++) {
        if (headings[j].getBoundingClientRect().top <= 120) {
          active = j;
        }
      }

      for (var k = 0; k < links.length; k++) {
        if (k === active) {
          links[k].classList.add('cn-toc__link--active');
        } else {
          links[k].classList.remove('cn-toc__link--active');
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Mobile TOC toggle
    var tocTitle = document.querySelector('.cn-article-body__toc-title');
    if (tocTitle && tocWrapper) {
      tocTitle.addEventListener('click', function () {
        tocWrapper.classList.toggle('is-open');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
